import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';

@Component({
  selector: 'app-my-courses',
  templateUrl: './my-courses.component.html',
  styleUrls: ['./my-courses.component.scss']
})
export class MyCoursesComponent implements OnInit {

  packages = {
    ongoing: [],
    completed: []
  };
  mainData = {
    ongoing: [],
    completed: []
  };
  userID:string;
  active:string;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService) { }

  ngOnInit() {

    this.userID = this.helperService.getToken();
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`courses`);
    }

    let courseData = {
      //token:this.helperService.studented_atob(this.helperService.getToken()),
      userID:this.helperService.studented_atob(this.helperService.getUserID()),
      hostID:this.helperService.studented_atob(this.helperService.getHostID())
    }

    this.apiService.courseList(courseData).subscribe(async (res: any)=>{
      
      for (let i = 0; i < res.data.courseListData.data.length; i++) {
        const el = res.data.courseListData.data[i];
        if (el.STATUS === 1) {
          this.packages['ongoing'].push(el);
          this.mainData['ongoing'].push(el);
        } else if (el.STATUS != 1) {
          this.packages['completed'].push(el);
          this.mainData['completed'].push(el);
        }
      }
      

    },async err => {
     
    })


  }
  viewDetails(packageId,scheduleId){
    
    this.router.navigateByUrl(`classDetails` + `/`+ packageId + `/`+ scheduleId,{skipLocationChange: true});
  }
 

  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  
  enrollment(){   
    this.router.navigateByUrl(`enrollment`);
  }

  segmentChanged(completed){
    

  }
  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  classes(){
    this.router.navigateByUrl(`courses`);
  }


}
